import { InjectionToken } from '@angular/core';

export const ADMIN_API_BASE_URL = new InjectionToken<string>('ADMIN_API_BASE_URL');
export const ADMIN_API_WS_URL = new InjectionToken<string>('ADMIN_API_WS_URL');
export const MAIN_APP_URL = new InjectionToken<string>('MAIN_APP_URL');
export const PUBLIC_API_ORIGIN = new InjectionToken<string>('PUBLIC_API_ORIGIN');

// Temporary alias maintained for backward compatibility until older imports are updated
export const METRICS_BASE_URL = ADMIN_API_BASE_URL;
